export type ChatOptions = { readonlyEnabled: boolean } & (ChatOptionsChannel | ChatOptionsDm);

export interface ChatOptionsChannel {
  type: 'channel';
  channelId: string;
}

export interface ChatOptionsDm {
  type: 'dm';
  userId: string;
}

export interface ChangePayload {
  userId?: string;
  channelId?: string;
  title: string;
  membersOnly: boolean;
}

export enum ChatConfigurationType {
  PORTAL_WIDGET = 'portalWidget',
}
export enum ChatConfigurationOptionsType {
  CHANNEL = 'channel',
  DM = 'dm',
}

export interface ChatConfigurationChannelOptions {
  type: ChatConfigurationOptionsType.CHANNEL;
  channelId: string;
  readonlyEnabled: boolean;
}

export interface ChatConfigurationDMOptions {
  type: ChatConfigurationOptionsType.DM;
  userId: string;
  readonlyEnabled: boolean;
}

export type ChatConfigurationOptions = ChatConfigurationChannelOptions | ChatConfigurationDMOptions;

export interface ChatConfiguration {
  key: string;
  type: ChatConfigurationType.PORTAL_WIDGET;
  orgId: string;
  scope: string;
  widgetId: string;
  title: string;
  options: ChatConfigurationOptions;
}
